import { render, staticRenderFns } from "./ProductSelectionCard.vue?vue&type=template&id=808aa526&scoped=true&"
import script from "./ProductSelectionCard.vue?vue&type=script&lang=js&"
export * from "./ProductSelectionCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductSelectionCard.vue?vue&type=style&index=0&id=808aa526&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "808aa526",
  null
  
)

export default component.exports